import { createStyles } from '@material-ui/core';

const styles = createStyles({
  footerContainer: {
    '-ms-grid-row': 3,
    height: 'auto',
    background: '#eee',
    padding: '3.57rem',
    borderTop: '1px solid #ddd',
    marginTop: '3.57rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '@media (max-width: 414px)': {
      fontSize: 12,
      padding: '0.7143rem',
      marginTop: 0,
      minHeight: 50
    }
  },
  strap: {
    textAlign: 'end'
  },
  links: {
    display: 'flex',
    flexDirection: 'row',

    '@media (max-width: 414px)': {
      display: 'flex',
      flexDirection: 'column'
    }
  }
});

export default styles;
